import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OverdueDebtComponent } from './overdue-debt/overdue-debt.component';

export const powerBIDashboardRoutes: Routes = [
  {
    path: 'power-bi-dashboard',
    children: [
      {
        path: 'overdue-debt',
        component: OverdueDebtComponent
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(powerBIDashboardRoutes)],
  exports: [RouterModule]
})
export class PowerBiDashboardRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/power-bi-dashboard/power-bi-dashboard-routing.module.ts